import { PRIVACY } from "@netkeep/legal";
import { LegalDocumentView } from "@/components/LegalDocumentView";

export default function PrivacyPage() {
  return <LegalDocumentView doc={PRIVACY} />;
}
